<main>
  <header><hubtype-logo href="https://www.hubtype.com/"></hubtype-logo></header>
  <router-outlet />
  <ng-content />
</main>
<footer>
  <nav>
    <ol>
      <li>
        <a href="https://www.hubtype.com/terms/privacy-policy" target="_blank">
          {{ privacyPolicy }}
        </a>
      </li>
      <li>
        <a href="https://www.hubtype.com/terms/cookies-policy" target="_blank">
          {{ cookiePolicy }}
        </a>
      </li>
      <li>
        <a
          href="https://www.hubtype.com/terms/terms-of-service"
          target="_blank"
        >
          {{ termsOfService }}
        </a>
      </li>
      <li>
        <a href="https://www.hubtype.com/terms/security-policy" target="_blank">
          {{ securityPolicy }}
        </a>
      </li>
    </ol>
    <ol>
      <li>
        <a href="https://www.linkedin.com/company/hubtype/" target="_blank">
          Linkedin
        </a>
      </li>
      <li>
        <a href="https://twitter.com/hubtype" target="_blank">Twitter</a>
      </li>
      <li
        >©{{ year }}<span> {{ allRightsReserved }}</span></li
      >
    </ol>
  </nav>

  <div class="app-version-wrapper">
    <app-version></app-version>
  </div>
</footer>
